import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-700" : ""} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}